import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Radio, RadioGroup, FormControl, FormLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import { setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import RemarkListPage from "components/remark/page/RemarkListPage";
import { setitemIdBeingComment } from "store/slice/AppSlice";
import CommentMgmt from "./comment/CommentMgmt";
import { initRefreshCommentList,setEnableAddComment } from "store/slice/AppSlice";

export default function TaskSpaceDesignerRevisePM() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse } = useSelector((state) => state.appslice.wkflow);
  const {remarkList} = useSelector((state) => state.pharmaslice);

  useEffect(() => {
    getListAPI(setPmorderList, () => { });
    dispatch(setitemIdBeingComment(productObj.id));
  }, []);
  useEffect(() => {
    if (taskApiResponse && taskApiResponse.success !== undefined) {
      dispatch(initRefreshCommentList());
      dispatch(setEnableAddComment(false));
    }
  },[taskApiResponse]);

  
  useEffect(() => {
    if (confirmed) {
      dispatch(setCompleteTaskButtonEnabled(true));
      dispatch(setReferbackTaskButtonEnabled(false));
    } else {
      
      dispatch(setCompleteTaskButtonEnabled(false));
      dispatch(setReferbackTaskButtonEnabled(true));
    }
  }, [confirmed]);

  const handleRadioChange = (e) => {
    const value = e.target.value === "yes";
    setConfirmed(value);
    dispatch(setCompleteTaskButtonEnabled(value));
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
      <Grid container sx={{ width: '100%' }}>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <ProductInfo productId={productObj.id} />
        </Grid>
        <Grid item lg={8} md={8} sm={8} xs={12} sx={{ pt: 2 }}>
          <Grid container sx={{ width: '100%', }}>

            
            
            <Grid item lg={6} md={12} sm={12} xs={12} sx={{  borderRadius: 2,}}>
              <Box sx={{width:'100%', backgroundColor: "white", borderRadius: 2, p: 1 }}>
                <CommentMgmt maxHeight='64vh'/>
              </Box>
              
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12} sx={{ }}>
              <Box sx={{ width: '100%', pl:2}}>
                
              <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 1, }}>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel component="legend" sx={{ mb: 2 }}>
                    I confirm that Packaging Material is corrected as per QA Recomendations.
                  </FormLabel>
                  <RadioGroup
                    value={confirmed ? "yes" : "no"}
                    onChange={handleRadioChange}
                    row // horizontal options
                  >
                    <FormControlLabel
                      value="yes"
                      control={
                        <Radio
                          color="primary"
                          disabled={taskApiResponse && taskApiResponse.success !== undefined}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      value="no"
                      control={
                        <Radio
                          color="primary"
                          disabled={taskApiResponse && taskApiResponse.success !== undefined}
                        />
                      }
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}